import {useEffect} from "react";
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import AOS from "aos";
import NavScrollTop from './components/NavScrollTop';
import HomeOne from './pages/HomeOne';
import HomeTwo from './pages/HomeTwo';
import HomeThree from './pages/HomeThree';
import About from './pages/About';
import Service from './pages/Service';
import Work from './pages/Work';
import WorkDetails from './pages/WorkDetails';
import BlogGrid from './pages/BlogGrid';
import BlogClassic from './pages/BlogClassic';
import BlogDetails from './pages/BlogDetails';
import BlogCategories from './pages/BlogCategories';
import BlogTag from './pages/BlogTag';
import Contact from './pages/Contact';
import OnProgress from "./pages/OnProgress";
import Sambutan from "./pages/Sambutan";
import Guru from "./pages/Guru";

// CSS File Here
import "aos/dist/aos.css";
import 'react-modal-video/scss/modal-video.scss';
import './assets/scss/style.scss';
import Karyawan from "./pages/Karyawan";



function App() {
  useEffect(() => {
    AOS.init({
        offset: 80,
        duration: 1000,
        once: true,
        easing: 'ease',
    });
    AOS.refresh();
    
  }, [])
  return (
      <Router>
        <NavScrollTop>
            <Switch>
              <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={HomeOne}/>
              <Route path={`${process.env.PUBLIC_URL + "/profil"}`} component ={About} />
              <Route path={`${process.env.PUBLIC_URL + "/guru"}`} component ={Guru} />
              <Route path={`${process.env.PUBLIC_URL + "/karyawan"}`} component ={Karyawan} />
              <Route path={`${process.env.PUBLIC_URL + "/sambutan"}`} component ={Sambutan} />
              <Route path={`${process.env.PUBLIC_URL + "/program"}`} component ={OnProgress} />
              <Route path={`${process.env.PUBLIC_URL + "/sekolah"}`} component ={OnProgress} />
              <Route path={`${process.env.PUBLIC_URL + "/fasilitas"}`} component ={OnProgress} />
              <Route path={`${process.env.PUBLIC_URL + "/artikel"}`} component ={OnProgress} />
              <Route path={`${process.env.PUBLIC_URL + "/galeri"}`} component ={OnProgress} />
              <Route path={`${process.env.PUBLIC_URL + "/kontak"}`} component ={OnProgress} />


              <Route path={`${process.env.PUBLIC_URL + "/home-one"}`} exact component={HomeOne}/>
              <Route path={`${process.env.PUBLIC_URL + "/home-two"}`} component={HomeTwo}/>
              <Route path={`${process.env.PUBLIC_URL + "/home-three"}`} component={HomeThree}/>
              <Route path={`${process.env.PUBLIC_URL + "/about"}`} component ={About} />
              <Route path={`${process.env.PUBLIC_URL + "/service"}`} component ={Service} />
              <Route path={`${process.env.PUBLIC_URL + "/work"}`} component ={Work} />
              <Route path={`${process.env.PUBLIC_URL + "/work-details/:id"}`} component ={WorkDetails} />
              <Route path={`${process.env.PUBLIC_URL + "/blog-grid"}`} component ={BlogGrid} />
              <Route path={`${process.env.PUBLIC_URL + "/blog-classic"}`} component ={BlogClassic} />
              <Route path={`${process.env.PUBLIC_URL + "/tag/:slug"}`} component ={BlogTag} />
              <Route path={`${process.env.PUBLIC_URL + "/category/:slug"}`}component ={BlogCategories} />
              <Route path={`${process.env.PUBLIC_URL + "/blog-details/:id"}`}component ={BlogDetails} />
              <Route path={`${process.env.PUBLIC_URL + "/contact"}`} component ={Contact} />
            </Switch>
          </NavScrollTop>
      </Router>
  );
}

export default App;
